import React, { useEffect, useState } from 'react';
const NAMES = ['Juan', 'Carlos', 'Martín', 'Roberto', 'Diego', 'Pablo', 'Sergio', 'Andrés', 'Fernando', 'Miguel', 'Gustavo', 'Raúl', 'Eduardo', 'Hernán', 'Facundo', 'Alejandro', 'Nicolás', 'Damián', 'Oscar', 'Ramiro'];
const COUNTRIES = ['Argentina', 'México', 'Colombia', 'Chile', 'Perú', 'Venezuela', 'Ecuador', 'Bolivia', 'Uruguay', 'Paraguay', 'Costa Rica', 'Panamá', 'Guatemala', 'Honduras', 'El Salvador', 'Nicaragua', 'República Dominicana'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function scrollToCompra() {
  window.open('https://pay.hotmart.com/R105070415Y?checkoutMode=10', '_blank');
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);
  const [name, setName] = useState('');
  const [country, setCountry] = useState('');
  useEffect(() => {
    const showPopup = () => {
      setName(getRandomItem(NAMES));
      setCountry(getRandomItem(COUNTRIES));
      setExiting(false);
      setVisible(true);
      setTimeout(() => {
        setExiting(true);
        setTimeout(() => {
          setVisible(false);
          scheduleNext();
        }, 500);
      }, 4000);
    };
    const scheduleNext = () => {
      const delay = 8000 + Math.random() * 4000;
      setTimeout(showPopup, delay);
    };
    const initialDelay = setTimeout(showPopup, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  if (!visible) return null;
  return <button onClick={scrollToCompra} className={`fixed bottom-4 left-4 z-50 rounded-lg shadow-2xl p-4 max-w-xs cursor-pointer transition-shadow bg-gradient-to-r from-amber-950 to-gray-900 border-2 border-amber-500 ${exiting ? 'popup-exit' : 'popup-enter'}`} data-id="element-263">
      <div className="flex items-center gap-3" data-id="element-264">
        <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 bg-amber-500" data-id="element-265">
          <span className="text-white text-lg" data-id="element-266">🏆</span>
        </div>
        <div className="text-left" data-id="element-267">
          <p className="text-sm font-bold text-amber-300" data-id="element-268">
            {name} de {country}
          </p>
          <p className="text-xs text-amber-100" data-id="element-269">
            acaba de comprar el Mega Pack
          </p>
          <p className="text-xs font-semibold mt-0.5 text-amber-400" data-id="element-270">
            Hace {Math.floor(Math.random() * 5) + 1} minutos
          </p>
        </div>
      </div>
    </button>;
}